@import "@zvuk-b2b/react-uikit/ui/styles/_variables";
@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

.Toaster {
    display: flex;
    align-items: center;
    font-size: $font-size-14;
    line-height: $line-height-20;
    font-weight: $font-weight-medium;
    color: $color-white;
    position: fixed;
    transition: bottom $transition-duration-l;
    box-sizing: border-box;
    z-index: $z-index-layer-xxxl;
    cursor: pointer;

    @include media-desktop {
        width: fit-content;
        margin: 0 auto;
        left: 0;
        right: 0;
        padding: 14px $ceil * 3;
        border-radius: $border-radius-8;
        max-width: 100%;
        text-align: center;

        &[data-type-opened=true] {
            bottom: $ceil * 3;
        }
    }

    @include media-mobile {
        width: 100%;
        left: 0;
        border-radius: 0;
        padding: 14px $ceil * 2;

        &[data-type-opened=true] {
            bottom: 0;
        }
    }

    &[data-type-opened=false] {
        bottom: -100%;
    }
}
